import { jsx, jsxs, Fragment } from "react/jsx-runtime";
import { ModalButtonRow, Button } from "@flatfile/design-system";
import { useState } from "react";
import { named } from "../../../utils/named.js";
import AlertModal from "./AlertModal.js";
import { useTranslation } from "react-i18next";
const CopyAlertModal = (props) => {
  const [isDownloading, setIsDownloading] = useState(false);
  const { t } = useTranslation();
  const handleDownload = async () => {
    if (!props.onDownload)
      return;
    setIsDownloading(true);
    try {
      await props.onDownload();
      props.onClose();
    } catch (err) {
      return console.warn(err);
    }
    setIsDownloading(false);
  };
  return /* @__PURE__ */ jsx(
    AlertModal,
    {
      "data-testid": "tt-copy-alert-modal",
      text: {
        heading: t("sheet.table.modals.copyAlert.heading"),
        description: /* @__PURE__ */ jsxs(Fragment, { children: [
          /* @__PURE__ */ jsx("div", { children: t("sheet.table.modals.copyAlert.description") }),
          props.onDownload && /* @__PURE__ */ jsx("div", { children: t("sheet.table.modals.copyAlert.download") })
        ] })
      },
      children: /* @__PURE__ */ jsxs(ModalButtonRow, { children: [
        /* @__PURE__ */ jsx(
          Button,
          {
            variant: props.onDownload ? "tertiary-border" : "warning",
            onPress: props.onClose,
            label: props.onDownload ? t("sheet.table.modals.copyAlert.cancelButton") : "Dismiss"
          }
        ),
        props.onDownload && /* @__PURE__ */ jsx(
          Button,
          {
            onPress: handleDownload,
            isDisabled: isDownloading,
            label: t("sheet.table.modals.copyAlert.downloadButton")
          }
        )
      ] })
    }
  );
};
named("CopyAlertModal", CopyAlertModal);
export {
  CopyAlertModal as default
};
